import { AuditLogRecordType } from '../../interfaces/management/schema.interface';
import { EventMeta } from '../../interfaces/meta.interface';

const records: Partial<{ [key in AuditLogRecordType]: { [key: string]: EventMeta<any> } }> = {

}

export default records;